import api from "../../Http/global-vars";
import { FETCH_CGU } from "../types";

export const fetchCgu = () => {
  return async (dispatch) => {
    // const config = {
    //   headers: {
    //     Authorization: `Bearer ${window.sessionStorage.getItem("userToken")}`,
    //   },
    // };
    const url = api + "general_condition_use/";
    await fetch(url)
      .then(async (res) => {
        const data = await res.json();
        // console.log("data categories", data)
        dispatch({
          type: FETCH_CGU,
          payload: data.results.sort((a, b) => b?.id - a?.id),
        });
      })
      .catch((error) => console.log("error", error?.response));
  };
};
